import templateUrl from "emun.auth/verify-email-tin.htm";
import controller from "emun.auth/verify-email-tin.controller";

export default {
  controller,
  templateUrl,
	bindings: {
		registrationUrl: "@",
		loginUrl: "@"
	}
};
